// extracted by mini-css-extract-plugin
export var backContainer = "listGdd-module--back-container--3f616";
export var backLink = "listGdd-module--back-link--d2835";
export var backToSite = "listGdd-module--back-to-site--6afc1";
export var imgLogo = "listGdd-module--img-logo--7ab73";
export var listGdd = "listGdd-module--list-gdd--11acf";
export var titleGdd = "listGdd-module--title-gdd--f1986";